import React, { memo } from "react"
import styled from "@emotion/styled"
import Bookmark from "../../icons/svg/Bookmark"
import { graphql, StaticQuery } from "gatsby"
import Img from "gatsby-image"
import { breakpoints, color } from "../../utils/style"

const CasinoProvidersWrapper = styled("div")`
  .h1 {
    margin: 2rem 0;
  }
  ul {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    list-style: none;
  }
  li {
    flex-basis: 32%;
    position: relative;
  }

  .item-link {
    position: relative;
    display: block;
    overflow: hidden;

    .image-container {
      position: relative;
      border-radius: 10px;
    }
    .button-container {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      padding: 20px;
      transition: all 0.2s ease-in-out;
      overflow: hidden;
      border-radius: 10px;
    }

    .gatsby-image-wrapper {
      border-radius: 10px;
    }

    .text-part-2 {
      padding: 7px 0 54px;
    }

    .h5 {
      display: block;
      font-size: 1.5rem;
      line-height: 2rem;
      color: ${color.white};
      max-height: 26px;
      margin: 24px 0;
      overflow: hidden;
    }

    .button {
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -54px;
      margin-top: -25px;
      visibility: hidden;
      opacity: 0;
      transition: all 0.2s ease-in-out;
    }

    .excerpt {
      display: block;
      font-size: 14px;
      line-height: 20px;
      max-height: 99px;
      overflow: hidden;
    }

    &:hover,
    &:active {
      text-decoration: none;
      color: ${color.white};
      border: none;
      .button-container {
        background: rgba(0, 0, 0, 0.8);
      }
      .button {
        visibility: visible;
        opacity: 1;
      }
    }
    .gatsby-image-wrapper {
      height: 100%;
    }
  }

  @media (max-width: ${breakpoints.lg}) {
    li {
      flex-basis: 48%;
    }
  }

  @media (max-width: ${breakpoints.sm}) {
    margin-bottom: 20px;
    .h3 {
      font-size: 18px;
      line-height: 20px;
      margin-bottom: 0.7rem;
    }
    li {
      flex-basis: 100%;
      margin-bottom: 20px;
    }
    .item-link {
      .h5 {
        margin: 0 0 10px;
      }
      .text-part-2 {
        padding: 7px 0 20px;
      }
    }
  }
`

const CasinoProviders = () => {
  return (
    <StaticQuery
      query={graphql`
        {
          allWordpressPage(filter: { slug: { eq: "home-page" } }) {
            edges {
              node {
                acf {
                  casino_providers {
                    alt_text
                    title
                    path
                    acf {
                      slide_url
                      slide_title
                      slide_description
                    }
                    localFile {
                      childImageSharp {
                        fluid(maxWidth: 360) {
                          ...GatsbyImageSharpFluid_withWebp_noBase64
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `}
      render={data => {
        const page = data?.allWordpressPage?.edges[0]?.node
        const gallery = page?.acf?.casino_providers
        return (
          <CasinoProvidersWrapper>
            <h2 className="h1 rich-design with-icon">
              <Bookmark />
              <span>บริการเพิ่มเติมนอกเหนือจาก Casino Royal1688</span>
            </h2>
            <ul>
              {gallery.map(item => {
                const localFile = item?.localFile || {}
                return (
                  <li key={item.path}>
                    {item?.acf?.slide_url ? (
                      <a className="item-link" href={item.acf.slide_url}>
                        <div className="image-container">
                          {localFile?.childImageSharp &&
                            localFile?.childImageSharp?.fluid && (
                              <Img
                                fluid={localFile.childImageSharp.fluid}
                                alt={
                                  item.alt_text
                                    ? item.alt_text
                                    : "royal-1688.net"
                                }
                                fadeIn={false}
                                loading="eager"
                              />
                            )}
                          <div className="button-container">
                            <span className="button transparent-button-gold">
                              คลิกเลย
                            </span>
                          </div>
                        </div>
                        <div className="text-part-2">
                          <span className="h5">{item?.acf?.slide_title}</span>
                          <div
                            className="excerpt"
                            dangerouslySetInnerHTML={{
                              __html: item?.acf?.slide_description,
                            }}
                          />
                        </div>
                      </a>
                    ) : (
                      <div className="item-link">
                        <div className="image-container">
                          {localFile?.childImageSharp &&
                            localFile?.childImageSharp?.fluid && (
                              <Img
                                fluid={localFile.childImageSharp.fluid}
                                alt={
                                  item.alt_text
                                    ? item.alt_text
                                    : "royal-1688.net"
                                }
                                fadeIn={false}
                                loading="eager"
                              />
                            )}
                        </div>
                        <div className="text-part-2">
                          <span className="h5">{item?.acf?.slide_title}</span>
                          <div
                            className="excerpt"
                            dangerouslySetInnerHTML={{
                              __html: item?.acf?.slide_description,
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </li>
                )
              })}
            </ul>
          </CasinoProvidersWrapper>
        )
      }}
    />
  )
}

export default memo(CasinoProviders)
